import { Component, Input } from '@angular/core';
import { ProductAttrValue } from '../../../models/product';
import { CartService } from '../../../services/cart.service';
import { DrawerService } from '../../../services/drawer.service';
import { MessageService } from '../../../services/message.service';
import { Button } from '../../common/button/button';

@Component({
  selector: 'app-add-to-cart-button',
  imports: [Button],
  templateUrl: './add-to-cart-button.html',
  styleUrl: './add-to-cart-button.scss',
})
export class AddToCartButton {
  @Input({ required: true }) product_id: number = 0;
  @Input({ required: true }) product_attr_values: ProductAttrValue[] = [];
  @Input({ required: true }) product_priced_attr_value?: ProductAttrValue;
  loading: boolean = false;

  constructor(
    private messageService: MessageService,
    private cartService: CartService,
    private drawerService: DrawerService
  ) {}

  async add() {
    if (!this.product_priced_attr_value) {
      return;
    }
    try {
      this.loading = true;
      const r = await this.cartService.addShoppingCartItem({
        product_id: this.product_id,
        quantity: 1,
        product_attr_value_ids: this.product_attr_values.map((attr) => attr.id),
        product_priced_attr_value_id: this.product_priced_attr_value?.id,
      });
      this.messageService
        .open('Added to cart', 'View Cart')
        .onAction()
        .subscribe(() => {
          this.drawerService.openCart();
        });
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }
}
